<template>
  <div class="bg-CAF-mobile_IB">
    <div class="main-content-CAF-mobile-IB">
      <ImagemComFallback
        :src="$theme.logo"
        srcDefault="/assets/imgs/logo.svg"
        width="25%"
        contain
      />
      <p class="color-title title-CAF-mobile_IB mb-8" style="text-align: center;">O acesso a esta funcionalidade não está disponível via celular.</p>
      <p class="content content-CAF-mobile_IB mb-6 px-8">Por favor, utilize um navegador em um computador para continuar.</p>
    </div>
    <div class="footer text-auxiliar-mobile_IB">
      <p>Para mais informações, entre em contato através dos nossos canais de atendimento:</p>
      <span>
        {{
          dadosContato
            ? `${dadosContato.Telefone} | ${dadosContato.Email}`
            : "(11) 4858-8650 | atendimento@moneyspan.com.br"
        }}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      dadosContato: null
    }
  },
  mounted () {
    const dadosContato = JSON.parse(localStorage.getItem('dadosContato'));
    this.$set(this, 'dadosContato', dadosContato);
  }
}
</script>
<style scoped>
.color-title {
  color: #2171BD;
}

.content {
  color: #191919;
}

.footer {
  position: fixed;
  bottom: 5%;
  line-height: 16.41px;
  color: #3A3939;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  text-align: center;
  width: 100%;
}

.footer span {
  color: #0094FF;
}
</style>
